module.exports = __webpack_public_path__ + "img/email.38099a8b.svg";